module.exports = __webpack_public_path__ + "static/media/upload-media.83b00fdf.svg";